import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAccessToken } from "../../assets/store/auth";
import Loader from "../../components/ui/loader";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const accessToken = searchParams.get("access_token");
    if (accessToken) {
      dispatch(setAccessToken(accessToken));

      window.history.replaceState({}, "", "/settings");

      setTimeout(() => navigate("/settings"), 0);
    } else {
      navigate("/sign-in", { replace: true });
    }
  }, [location, navigate, dispatch]);

  return <Loader />;
};

export default AuthCallback;
